export const headerKeywordStyle = theme => ({
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    textField: {
        width: '200px',
        ':first-child': {
            textAlign: 'center'
        }
    },
})